"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.askForVoucher.name': '优惠券请求',
    'tools.askForVoucher.description': '从用户消息中检测优惠券或折扣请求，并触发客户端优惠券操作',
};
